// extracted by mini-css-extract-plugin
export var container = "_6u-0";
export var infoButton = "_6u-1";
export var label = "_6u-3";
export var labelExpanded = "_6u-4";
export var price = "_6u-5";
export var priceExpanded = "_6u-6";
export var title = "_6u-2";